import React, { CSSProperties, forwardRef, MouseEventHandler, ReactNode } from "react"
import classNames from "classnames"
import styles from "./Action.module.scss"
import Button from "@mui/material/Button";

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean
  className?: string
  children?: ReactNode | ReactNode[]
  style?: object
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
  buttonColors?: {
    fill: string
    background: string
  }
  cursor?: CSSProperties["cursor"]
}

export const Action = forwardRef<HTMLButtonElement, Props>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ children, onClick, buttonColors, cursor, style, className, active, ...props }, ref) => {
    return (
      <Button
        onClick={onClick}
        ref={ref}
        className={classNames(styles.Action, className)}
        tabIndex={0}
        sx={
          {
            ...style,
            cursor,
          }
        }
        {...props}
        color={"inherit"}
      >
        {children}
      </Button>
    )
  },
)
